import React, { useContext, useEffect, useRef, useState, useMemo } from 'react';
import Room from '../Room'; // Adjust the path as needed
import TableInfo from '../TableInfo'; // Adjust the path as needed
import { ThemeContext } from '../ThemeContext/ThemeContext';
import { Grid } from '@mui/material';
import ChatList from '../ChatList';
import { useWebSocket } from '../WebSocketContext/WebSocketContext';

const RoomListTable = ({ rooms, selectedRoom, handleSelectRoom,
  setOpenChat, setMessages, inProgressRooms,
  operatorSendMessage, currentRoomId, roomRefs,
  messages, whatsAppChats,
  ...props }) => {

  const roomRef = useRef();
  const { theme } = useContext(ThemeContext);

  // Memoiza rows para evitar recriação a cada render
  // Usa apenas as dependências essenciais para evitar loops
  const rows = useMemo(() => {
    // NAO troque este filtro pelo predicado `ehSalaDeWhatsapp()`.
    //
    // Ele nasceu para tirar da lista do operador as salas da camada
    // whatsapp-web.js, que eram desenhadas logo abaixo por `whatsAppRows`, a
    // partir do feed de `whatsAppChats`. Essa camada morreu em 31/08: o feed
    // nunca mais chega, `whatsAppRows` e sempre vazio, e
    // `whatsapp_instance_id` e sempre nulo -- entao hoje o filtro nao tira
    // nada, e e por isso que a conversa da Meta aparece aqui e o operador
    // consegue atende-la. Fazer este filtro voltar a reconhecer WhatsApp
    // (agora pelo telefone) sumiria com TODA conversa de WhatsApp da tela,
    // sem nada em lugar nenhum para desenha-la no lugar.
    return rooms.filter(room => !room.whatsapp_instance_id).map(room => ({
    id: room.room_id,
    roomComponent: (
      <Room
        ref={roomRefs[room.room_id]}
        key={room.room_id}
        room={room}
        handleSelectRoom={(handleSelectRoom)}
        selectedRoom={selectedRoom}
        currentRoomId={currentRoomId}
        setMessages={setMessages}
        setOpenChat={setOpenChat}
        inProgressRooms={inProgressRooms}
        operatorSendMessage={operatorSendMessage}
        {...props}
      />
    )
  }));
  }, [rooms, selectedRoom, currentRoomId, inProgressRooms, operatorSendMessage]);

  // Memoiza columns para evitar recriação
  const columns = useMemo(() => [
    { field: 'roomComponent', headerName: 'Room', width: '100rem', renderCell: (params) => params.value, flex: 1 }
  ], []);

  // Memoiza whatsAppRooms
  const whatsAppRooms = useMemo(() => {
    return whatsAppChats.filter(chat =>
    rooms.some(room =>
      room.whatsapp_instance_id && room.room_id === chat.id._serialized
    )
    );
  }, [whatsAppChats, rooms]);

  // Memoiza whatsAppRows
  const whatsAppRows = useMemo(() => {
    return whatsAppRooms.map((chat, index) => ({
    id: `${chat.id.user}-${index}`,
    whatsAppComponent: (
      <ChatList
        ref={roomRefs[chat.room_id]}
        chats={[chat]}
        chat={chat}
        messages={messages}
        handleSelectRoom={handleSelectRoom}
        selectedRoom={selectedRoom}
        setMessages={setMessages}
      />
    )
  }));
  }, [whatsAppRooms, roomRefs, messages, handleSelectRoom, selectedRoom, setMessages]);

  // Memoiza whatsAppColumns
  const whatsAppColumns = useMemo(() => [
    { field: 'whatsAppComponent', headerName: 'Room', width: '100rem', renderCell: (params) => params.value, flex: 1 }
  ], []);

  return (
    <Grid className='table-row' sx={{
      maxHeight: '38rem', overflowY: 'auto', overflowX: 'hidden',
      margin: '10px', borderRadius: '10px', backgroundColor: 'transparent',
      cursor: 'pointer'
    }}>
      {rows.length > 0 && (
        <TableInfo
          rows={rows}
          columns={columns}
          headerHeight={0.00001}
          columnHeader={'none'}
          autoHeight={true}
          isBorder={false}
          color={theme.palette.secondary.main}
          isChatList={true}
        />
      )}
      {whatsAppRows.length > 0 && (
        <TableInfo
          rows={whatsAppRows}
          columns={whatsAppColumns}
          headerHeight={0.00001}
          columnHeader={'none'}
          autoHeight={true}
          isBorder={false}
          color={theme.palette.secondary.main}
          isChatList={true}
        />
      )}
      
      <div id="sentinel" style={{ height: "1px", background: "transparent" }}></div>

    </Grid>
  );
};

export default RoomListTable;
